var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "flex flex-col items-center mb-6" }, [
      _c("div", { staticClass: "px-4 mb-6" }, [
        _c("img", {
          staticClass:
            "shadow rounded max-w-full h-auto align-middle border-none",
          staticStyle: { width: "150px" },
          attrs: { alt: "...", src: _vm.user.avatar }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex gap-6" }, [
      _c(
        "div",
        { staticClass: "flex w-1/2 flex-col" },
        [
          _c("form-item", {
            attrs: { label: "Full Name" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("p", { staticClass: "text-left font-bold" }, [
                      _vm._v(_vm._s(_vm.user.name))
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            attrs: { label: "Email" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("p", { staticClass: "text-left font-bold" }, [
                      _vm._v(_vm._s(_vm.user.email))
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.isArtist ||
                  (_vm.isDetailArtis &&
                    (_vm.isAdmin || _vm.isSuperAdmin || _vm.isOps)),
                expression:
                  "isArtist || (isDetailArtis && (isAdmin || isSuperAdmin || isOps))"
              }
            ],
            attrs: { label: "Birthdate" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("p", { staticClass: "text-left font-bold" }, [
                      _vm._v(_vm._s(_vm.user.dob || "-"))
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.isArtist ||
                  (_vm.isDetailArtis &&
                    (_vm.isAdmin || _vm.isSuperAdmin || _vm.isOps)),
                expression:
                  "isArtist || (isDetailArtis && (isAdmin || isSuperAdmin || isOps))"
              }
            ],
            attrs: { label: "Bio" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("div", { staticClass: "flex flex-col" }, [
                      _c("p", { staticClass: "text-left font-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.user.bio_status == 1
                              ? _vm.user.biodata || "-"
                              : _vm.user.bio
                          ) + " "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-xs text-center font-semibold inline-block py-1 px-2 uppercase rounded uppercase last:mr-0 mr-1 w-64",
                          class:
                            _vm.user.bio_status == 1
                              ? "text-green-600 bg-green-200"
                              : "text-orange-600 bg-orange-200"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.user.bio_status == 1
                                ? "Published"
                                : "Waiting for Review"
                            )
                          )
                        ]
                      )
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _vm.isDetailArtis
            ? _c("form-item", {
                attrs: { label: "Total Earning" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  parseFloat(_vm.user.earning).toFixed(2) || 0
                                )
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  3380711430
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isDetailArtis
            ? _c("form-item", {
                attrs: { label: "Balance" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  parseFloat(_vm.user.balance).toFixed(2) || 0
                                )
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  3049336024
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isDetailArtis
            ? _c("form-item", {
                attrs: { label: "MusicVerse Cut" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function() {
                        return [
                          !_vm.isEditCalculation
                            ? _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(_vm._s(_vm.user.musicverse_cut || "-"))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEditCalculation
                            ? _c("Input", {
                                attrs: {
                                  placeholder: "ex. Video Name",
                                  error:
                                    _vm.$v.input.musicverse_cut.$dirty &&
                                    (!_vm.$v.inputCalc.musicverse_cut
                                      .required ||
                                      !_vm.$v.inputCalc.musicverse_cut.numeric),
                                  maxlength: "100"
                                },
                                on: {
                                  keyup: function($event) {
                                    return _vm.changeValueMVCut($event)
                                  }
                                },
                                model: {
                                  value: _vm.inputCalc.musicverse_cut,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.inputCalc,
                                      "musicverse_cut",
                                      $$v
                                    )
                                  },
                                  expression: "inputCalc.musicverse_cut"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEditCalculation
                            ? _c(
                                "div",
                                { staticClass: "flex flex-col pt-2" },
                                [
                                  _vm.$v.inputCalc.musicverse_cut.$dirty &&
                                  !_vm.$v.inputCalc.musicverse_cut.required
                                    ? _c("text-error", {
                                        attrs: {
                                          text: "Please fill MusicVerse Cut."
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$v.inputCalc.musicverse_cut.$dirty &&
                                  !_vm.$v.inputCalc.musicverse_cut.numeric
                                    ? _c("text-error", {
                                        attrs: { text: "Must be numeric." }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  3060189662
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isDetailArtis
            ? _c("form-item", {
                attrs: { label: "Artist Cut" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function() {
                        return [
                          !_vm.isEditCalculation
                            ? _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(_vm._s(_vm.user.artist_cut || "-"))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEditCalculation
                            ? _c("Input", {
                                attrs: {
                                  placeholder: "ex. Video Name",
                                  error:
                                    _vm.$v.input.artist_cut.$dirty &&
                                    (!_vm.$v.inputCalc.artist_cut.required ||
                                      !_vm.$v.inputCalc.artist_cut.numeric),
                                  maxlength: "100"
                                },
                                on: {
                                  keyup: function($event) {
                                    return _vm.changeValueArtistCut($event)
                                  }
                                },
                                model: {
                                  value: _vm.inputCalc.artist_cut,
                                  callback: function($$v) {
                                    _vm.$set(_vm.inputCalc, "artist_cut", $$v)
                                  },
                                  expression: "inputCalc.artist_cut"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEditCalculation
                            ? _c(
                                "div",
                                { staticClass: "flex flex-col pt-2" },
                                [
                                  _vm.$v.inputCalc.artist_cut.$dirty &&
                                  !_vm.$v.inputCalc.artist_cut.required
                                    ? _c("text-error", {
                                        attrs: {
                                          text: "Please fill Artist Cut."
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$v.inputCalc.artist_cut.$dirty &&
                                  !_vm.$v.inputCalc.artist_cut.numeric
                                    ? _c("text-error", {
                                        attrs: { text: "Must be numeric." }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  814493548
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isDetailArtis && _vm.isEditCalculation && !_vm.validCal
            ? _c("form-item", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("text-error", {
                            attrs: { text: "Maximum Total Calculation is 100 " }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  1821301042
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isDetailArtis && (_vm.isAdmin || _vm.isSuperAdmin || _vm.isOps)
            ? _c(
                "div",
                { staticClass: "flex flex-col md:flex-row" },
                [
                  _vm.isEditCalculation
                    ? _c("Button", {
                        attrs: {
                          variant: "default",
                          label: _vm.labelToggleCalc
                        },
                        on: { clicked: _vm.toggleEditCalculation }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isEditCalculation
                    ? _c("Button", {
                        attrs: {
                          variant: "primary",
                          label: _vm.labelToggleCalc
                        },
                        on: { clicked: _vm.toggleEditCalculation }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEditCalculation
                    ? _c("Button", {
                        attrs: {
                          disabled: _vm.isLoading && _vm.validCal,
                          variant: "primary",
                          label: "Save"
                        },
                        on: { clicked: _vm.saveCalc }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex w-1/2 flex-col" },
        [
          _c("form-item", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.isArtist ||
                  (_vm.isDetailArtis &&
                    (_vm.isAdmin || _vm.isSuperAdmin || _vm.isOps)),
                expression:
                  "isArtist || (isDetailArtis && (isAdmin || isSuperAdmin || isOps))"
              }
            ],
            attrs: { label: "Bank Name" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("p", { staticClass: "text-left font-bold" }, [
                      _vm._v(_vm._s(_vm.user.bank.bank || "-"))
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.isArtist ||
                  (_vm.isDetailArtis &&
                    (_vm.isAdmin || _vm.isSuperAdmin || _vm.isOps)),
                expression:
                  "isArtist || (isDetailArtis && (isAdmin || isSuperAdmin || isOps))"
              }
            ],
            attrs: { label: "Account Name" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("p", { staticClass: "text-left font-bold" }, [
                      _vm._v(_vm._s(_vm.user.bank.account_name || "-"))
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.isArtist ||
                  (_vm.isDetailArtis &&
                    (_vm.isAdmin || _vm.isSuperAdmin || _vm.isOps)),
                expression:
                  "isArtist || (isDetailArtis && (isAdmin || isSuperAdmin || isOps))"
              }
            ],
            attrs: { label: "Account Number" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("p", { staticClass: "text-left font-bold" }, [
                      _vm._v(_vm._s(_vm.user.bank.account_number || "-"))
                    ])
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.isArtist ||
                  (_vm.isDetailArtis &&
                    (_vm.isAdmin || _vm.isSuperAdmin || _vm.isOps)),
                expression:
                  "isArtist || (isDetailArtis && (isAdmin || isSuperAdmin || isOps))"
              }
            ],
            attrs: { label: "Swift Code" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("p", { staticClass: "text-left font-bold" }, [
                      _vm._v(_vm._s(_vm.user.bank.swift_code || "-"))
                    ])
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cee59a84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cee59a84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/ViewProfile.vue
// module id = null
// module chunks = 